import { ColorCircle } from "@/src/components/colorCircle";
import { openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import {
  AppointmentType,
  FolderItem,
  Income,
  Patient,
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, isCabinet, uid } from "@/src/utils/utils";
import { useEffect, useState } from "react";
import ExistingIncomesList from "./existingIncomesList";

function IncomeForm({
  current,
  onChange,
}: {
  current?: Income;
  onChange: (newValue: Income) => void;
}) {
  let [shouldUpdate, setShouldUpdate] = useState(0);
  let [income, setIncome] = useState(current || ({} as Income));
  function setNewValue(newValue: Income) {
    setIncome(newValue);
    onChange(newValue);
  }

  function calculateTotal() {
    let total = 0;
    income.appointmentTypes?.forEach((type) => {
      total += type?.price || 0;
    });

    return total;
  }

  let length = USER.get()?.service?.appointmentTypes?.length || 0;

  useEffect(() => {
    if (length == 1 && !income.appointmentTypes?.length)
      toggleAppointmentType(USER.get()?.service?.appointmentTypes?.[0]!);
  }, []);

  function toggleAppointmentType(type: AppointmentType) {
    let appointmentTypes = income.appointmentTypes || [];
    let isSelected = income.appointmentTypes?.find(
      (appointmentType) => appointmentType?.id === type.id
    );
    if (isSelected) {
      appointmentTypes = appointmentTypes.filter(
        (appointmentType) => appointmentType?.id !== type.id
      );
    } else {
      appointmentTypes.push(type);
    }

    setNewValue({
      ...income,
      basePrice: calculateTotal(),
      total: calculateTotal(),
      appointmentTypes,
    });
    setShouldUpdate(shouldUpdate + 1);
  }

  return (
    <div className="grid c1 gap10">
      <div className="field">
        <div className="label">Type de rendez-vous</div>
        <div
          className={`grid ${length == 0 || length == 1 ? "c1" : "c2"} gap10`}
        >
          {USER.get()?.service?.appointmentTypes?.map((type) => {
            if (!type) return;
            let isSelected = income.appointmentTypes?.find(
              (appointmentType) =>
                getItemId(appointmentType) === getItemId(type)
            );
            return (
              <div
                key={uid()}
                className="card grid c1 gap10"
                style={{
                  borderColor: isSelected ? type.color : "white",
                  borderWidth: "3px",
                  borderStyle: "solid",
                }}
                onClick={() => {
                  toggleAppointmentType(type);
                }}
              >
                <div className="cauto-1 acenter gap10">
                  <ColorCircle color={type.color}></ColorCircle>
                  {type.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Input
        key={`total${shouldUpdate}`}
        name="Montant total"
        type="number"
        value={income.total}
        onChange={(newValue) => {
          setNewValue({ ...income, total: newValue });
        }}
      />
    </div>
  );
}

export async function openIncomeForm({
  parent,
  patient,
}: {
  parent: FolderItem | null;
  patient: Patient;
}) {
  if (!isCabinet()) return true;
  if (!patient) throw new Error("Le patient est requis");

  let pendingIncomes = await apiFetch("incomes", "loadMany", {
    parentId: getItemId(parent) || "consultations:abcdef",
    endDate: null,
    startDate: null,
    statuses: ["pending"],
  });

  let income: Income = pendingIncomes?.[0] || {
    patient: patient,
    appointmentTypes: [],
    basePrice: 0,
    total: 0,
    credits: [],
    status: "pending",
    parent: parent,
    creator: getUserId(),
  };

  let isConfirmed = false;

  await openDrawer({
    id: "incomeDrawer",
    title: "Services à encaisser",

    content: (
      <div className="c1 gap10">
        <IncomeForm
          current={income}
          onChange={(newValue) => {
            income = newValue;
          }}
        />
        <ExistingIncomesList
          title="Services déjà encaissés"
          parentId={getItemId(parent)}
          patient={patient}
          statuses={["paid"]}
          emptyChild={<div></div>}
        />
      </div>
    ),
    onConfirm: async (e) => {
      await apiFetch("incomes", "addOne", {
        income,
      });
      isConfirmed = true;
    },
  });
  return isConfirmed;
}
